// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".textblock__roofline{margin-bottom:.667rem}.textblock__headline--large,.textblock__roofline{-webkit-hyphens:auto;-ms-hyphens:auto;hyphens:auto}.textblock__text p:last-child{margin-bottom:0}.textblock__link{margin-top:2rem}", ""]);
// Exports
module.exports = exports;
